const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/people/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { compactBooleanFilterSchema, compactPicklistFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
const resourceSearchSchema = z.object({
  locationId: compactPicklistFilterSchema,
  roleId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema,
  showDeactivatedMembers: compactBooleanFilterSchema,
  workloadSchemeId: compactPicklistFilterSchema,
  holidaySchemeId: compactPicklistFilterSchema,
  loopId: compactPicklistFilterSchema,
  employmentType: compactPicklistFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/settings/people/')({
  validateSearch: zodValidator(resourceSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.people)
  }),
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.people)
    }
  }
});